export const CONDITIONS = [
  { value: "stok_fazlasi", label: "Stok Fazlası", badge: "bg-blue-50 text-blue-700 border-blue-200" },
  { value: "defolu", label: "Defolu", badge: "bg-orange-50 text-orange-700 border-orange-200" },
  { value: "ikinci_el", label: "İkinci El", badge: "bg-purple-50 text-purple-700 border-purple-200" },
  { value: "tarlada_kalan", label: "Tarlada Kalan", badge: "bg-amber-50 text-amber-800 border-amber-200" },
  { value: "toplu_satis", label: "Toplu Satış", badge: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { value: "teshir_urunu", label: "Teşhir Ürünü", badge: "bg-rose-50 text-rose-700 border-rose-200" },
  { value: "hurda", label: "Hurda", badge: "bg-slate-100 text-slate-700 border-slate-300" },
  { value: "firsat", label: "Fırsat", badge: "bg-emerald-50 text-emerald-700 border-emerald-200" },
];

export const CONDITION_MAP = Object.fromEntries(CONDITIONS.map((c) => [c.value, c]));

export const UNITS = ["adet", "kg", "ton", "metre", "m²", "m³", "palet", "koli", "paket", "çuval", "kasa", "lot"];

export const PRICE_TYPES = [
  { value: "fixed", label: "Sabit Fiyat" },
  { value: "range", label: "Fiyat Aralığı" },
  { value: "tiered", label: "Kademeli Fiyat" },
  { value: "negotiable", label: "Pazarlık Yapılabilir" },
  { value: "offer", label: "Teklif Usulü" },
];

export const DELIVERY_OPTIONS = ["Kargo", "Elden Teslim", "Alıcı Adresine", "Alıcı Nakliyesi"];

export const HARVEST_STATUS = [
  { value: "tarlada", label: "Tarlada" },
  { value: "hasat_edildi", label: "Hasat Edildi" },
  { value: "hazir", label: "Teslime Hazır" },
];

export const HARVEST_MAP = Object.fromEntries(HARVEST_STATUS.map((h) => [h.value, h.label]));

export const LISTING_STATUS = {
  taslak: { label: "Taslak", cls: "bg-slate-100 text-slate-600" },
  onay_bekliyor: { label: "Onay Bekliyor", cls: "bg-amber-100 text-amber-700" },
  aktif: { label: "Aktif", cls: "bg-emerald-100 text-emerald-700" },
  reddedildi: { label: "Reddedildi", cls: "bg-red-100 text-red-700" },
  satildi: { label: "Satıldı", cls: "bg-blue-100 text-blue-700" },
  suresi_doldu: { label: "Süresi Doldu", cls: "bg-slate-100 text-slate-600" },
  pasif: { label: "Pasif", cls: "bg-slate-100 text-slate-600" },
};

export const REPORT_REASONS = [
  "Yanlış bilgi", "Dolandırıcılık şüphesi", "Yasaklı ürün", "Yanlış kategori", "Spam", "Diğer",
];

import { IL_LISTESI } from "@/lib/turkiye";

export const CITIES = IL_LISTESI;
